import {
  fetchCountryDonationSummaryService,
  // fetchCountriesService,
  fetchCountriesFromStoryblokService,
  fetchUsersActiveCountryService,
  fetchSliderStateService,
  fetchCountriesVaccinationApi,
} from "./api";
import {
  FETCHING_COUNTRIES,
  FETCHING_COUNTRIES_FAILED,
  FETCHING_COUNTRIES_SUCCESSFUL,
  FETCH_USERS_COUNTRY,
  FETCH_USERS_COUNTRY_FAILED,
  FETCH_USERS_COUNTRY_SUCCESS,
  FETCH_COUNTRY_DONATION_SUMMARY,
  FETCH_COUNTRY_DONATION_SUMMARY_FAILED,
  FETCH_COUNTRY_DONATION_SUMMARY_SUCCESS,

  FETCH_COUNTRY_SLIDER_STATE,
  FETCH_COUNTRY_SLIDER_STATE_FAILED,
  FETCH_COUNTRY_SLIDER_STATE_SUCCESS,

  FETCH_ACTIVE_COUNTRY_FROM_STORYBLOK,
  FETCH_ACTIVE_COUNTRY_FROM_STORYBLOK_FAILED,
  FETCH_ACTIVE_COUNTRY_FROM_STORYBLOK_SUCCESS,

  FETCH_VACCINATIONS,
  FETCH_VACCINATIONS_FAILED,
  FETCH_VACCINATIONS_SUCCESS
} from "./types";
import cache from "../../cache";
import getStory from "../../story";

export const fetchSliderStateAction = (params) => async (dispatch) => {
  try {
    dispatch({type: FETCH_COUNTRY_SLIDER_STATE});
    const response = await fetchSliderStateService(params)();
    dispatch({type: FETCH_COUNTRY_SLIDER_STATE_SUCCESS, state: response?.data})
  } catch (error) {
    dispatch({ type: FETCH_COUNTRY_SLIDER_STATE_FAILED})
  }

}

export const fetchCountrySummary = (params) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_COUNTRY_DONATION_SUMMARY });
    const response = await fetchCountryDonationSummaryService(params)();
    dispatch({
      type: FETCH_COUNTRY_DONATION_SUMMARY_SUCCESS,
      summary: response?.data,
    });
  } catch (error) {
    dispatch({ type: FETCH_COUNTRY_DONATION_SUMMARY_FAILED });
  }
};

export const fetchCountries = (params) => async (dispatch) => {
  try {
    dispatch({ type: FETCHING_COUNTRIES });
    const cacheKey = "countryList";
    let countries = cache.get(cacheKey);

    if (!countries) {
      const response = await fetchCountriesFromStoryblokService();
      countries = response?.data?.stories;
      cache.set(cacheKey, countries);
    }
    dispatch({ type: FETCHING_COUNTRIES_SUCCESSFUL, countries });
  } catch (error) {
    dispatch({ type: FETCHING_COUNTRIES_FAILED });
  }
};

export const fetchActiveCountry = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_USERS_COUNTRY });
    const response = await fetchUsersActiveCountryService();
    dispatch({ type: FETCH_USERS_COUNTRY_SUCCESS, country: response?.data });
  } catch (error) {
    dispatch({ type: FETCH_USERS_COUNTRY_FAILED });
  }
};

export const fetchCountryVaccinations = ({ country }) => async (dispatch) => {
  try {
    console.log(dispatch)
    dispatch({ type: FETCH_VACCINATIONS });
    const response = await fetchCountriesVaccinationApi({country})();
    dispatch({ type: FETCH_VACCINATIONS_SUCCESS, vaccination: response?.data });
  } catch (error) {
    dispatch({ type: FETCH_VACCINATIONS_FAILED });
  }
};

export const fetchSingleCountryFromStoryblok = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ACTIVE_COUNTRY_FROM_STORYBLOK });
    const response = await getStory(id);
    dispatch({ type: FETCH_ACTIVE_COUNTRY_FROM_STORYBLOK_SUCCESS });
    return response?.data?.story;
  } catch (error) {
    dispatch({ type: FETCH_ACTIVE_COUNTRY_FROM_STORYBLOK_FAILED });
  }
};

